export enum ActionTypes {
    CONFIG_LOADED = 'CD_CONFIG_LOADED',
    UI_INTEGRATE_UPDATED = 'CD_UI_INTEGRATE_UPDATED',
    UI_BYOD_UPDATED = 'CD_UI_BYOD_UPDATED',
    UI_WEBHOOK_UPDATED = 'CD_UI_WEBHOOK_UPDATED',
}



// WEBPACK FOOTER //
// ./src/sub-projects/codat/types/action-types.ts